const CHANNELS = [
    {title:'facebook', icon: 'facebook', active: true},
    {title:'fbg', icon: 'fbg', active: true},
    {title:'instagram', icon: 'instagram', active: true},
    {title:'linkedin', icon: 'linkedin', active: true},
    {title:'twitter', icon: 'twitter', active: true},
    {title:'google', icon: 'google', active: false},
    {title:'pinterest', icon: 'pinterest', active: false},
    {title:'reddit', icon: 'reddit', active: false},
    {title:'telegram', icon: 'telegram', active: false},
    {title:'tiktok', icon: 'tiktok', active: false},
    {title:'youtube', icon: 'youtube', active: false},
]

export default CHANNELS;